// src/hooks/useNavigation.ts
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';

export const useNavigation = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  
  return {
    navigate,
    params,
    searchParams,
    setSearchParams,
    location,
    
    // Navigation methods
    goToLanding: () => navigate('/'),
    goToPreview: () => navigate('/preview'),
    goToSignup: () => navigate('/signup'),
    goToOnboarding: () => navigate('/onboarding'),
    goToDashboard: () => navigate('/dashboard'),
    goToMatches: () => navigate('/discover'),
    goToMessages: () => navigate('/messages'),
    goToDiscover: () => navigate('/discover'),
    goToCondos: () => navigate('/condos'),
    goToCondoDetail: (condoId: string) => navigate(`/condos/${condoId}`),
    goToProfile: () => navigate('/profile'),
    goToSettings: () => navigate('/settings'),
    
    // Parameterized navigation
    goToMatch: (id: string) => navigate('/discover'),
    goToConversation: (conversationId: string) => navigate(`/messages/${conversationId}`),
    goToMatchWithAction: (id: string, action: string) => navigate('/discover'),
    
    // Query parameter navigation
    goToMatchesWithFilters: (filters: Record<string, string>) => {
      navigate('/discover');
    },
    
    // Browser navigation
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    
    // Utility methods
    isCurrentPath: (path: string) => location.pathname === path,
    getCurrentPath: () => location.pathname,
    getQueryParam: (key: string) => searchParams.get(key),
    setQueryParam: (key: string, value: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set(key, value);
      setSearchParams(newSearchParams);
    },
  };
};